import { MapMarkerType } from './MapMarkerType'

export const MapMarkerBaseOptions = new Map<MapMarkerType, google.maps.MarkerOptions>([
	[MapMarkerType.USER, { zIndex: 9999, optimized: false }],
	[MapMarkerType.BUILDING, { zIndex: 9990, optimized: true }],
	[MapMarkerType.SERVICE, { zIndex: 9992, optimized: false }],
	[MapMarkerType.COUPLING, { zIndex: 9991, optimized: false }],
])
